import React, { Fragment, useEffect, useState } from "react";
import * as Yup from "yup";
import { useFormik } from "formik";
import "./index.css";
import "../../custome.style.css";
import { Button, Form, FormGroup, Input } from "reactstrap";
import { getUserDetails, resendOtp, resetPassword, resetTempPassword, verifyOtp } from "../../api/auth";
import { formikResetPassword } from "./Constant";
import { useDispatch } from "react-redux";
import { useLocation, useNavigate } from "react-router";
import Loader from "../../components/Loader/Loader";
import { failed, success } from "../../utils/Tostify";
import OtpInput from "react-otp-input";
import { maskEmail, maskPhoneNumber } from "../../utils/common";
import phoneImg from "../../assets/images/phone.png";

function ResetPassword() {
const [isLoading, setIsLoading] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const queryParams = new URLSearchParams(window.location.search);
  const email = queryParams.get('email')?.replace(/ /g, "+");
  const [phoneNumber, setPhoneNumber] = useState();
  const decryptedEmail = JSON.parse(atob(email));
  const location = useLocation();
  const [showOtpInput, setShowOtpInput] = useState(false);
  const [otp, setOtp] = useState("");
  const [isOtpVerified, setIsOtpVerified] = useState(false);
  const [isOtpSent, setIsOtpSent] = useState(false);
  const [isChecked, setIsChecked] = useState(false);

	const formik = useFormik({
    ...formikResetPassword,
    validationSchema: Yup.object({
      newPassword: Yup.string()
      .matches(
        /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/,
        "Password must contain at-least 8 characters, one uppercase, one lowercase, one number and one special character."
      ).required("Required Field"),
      cPassword: Yup.string()
      .oneOf([Yup.ref('newPassword'), null], "Passwords must match")
      .required("Please confirm your password"),
      otp: location?.state?.isPasswordTemp ? Yup.string().notRequired() : Yup.string().required("Required OTP"),
      email: location?.state?.isPasswordTemp ?  Yup.string().required("Required email") :  Yup.string().notRequired()
    }),
    validateOnChange: true,
    onSubmit: async (values) => {
      let res;
      try {
        setIsLoading(true);
        if(location?.state?.isPasswordTemp){
          res = await resetTempPassword({ values, dispatch });
        }else{
          res = await resetPassword({ values:{...values,email: decryptedEmail}, email: email, dispatch });
        }
        if (res?.status === "SUCCESS") {
          setIsLoading(false);
          success(res?.message);
          navigate("/login");
        }else{
          setIsLoading(false);
          failed(res?.message);
        }
      } catch (error) {
        setIsLoading(false);
        failed(res?.message);
      }
    }
  });

  const getUser = async () => {
    let res;
    try {
        setIsLoading(true);
        res = await getUserDetails({ values: {email : decryptedEmail}, dispatch });
        if (res?.status === "SUCCESS") {
          setPhoneNumber(res.data.phone);
          setIsLoading(false);
        }
    } catch (error) {
        failed(res?.message);
        setIsLoading(false);
    }
};

  useEffect(() => {
    if(email){
      formik.setFieldValue("email", decryptedEmail);
      getUser();
    }
  }, [email]);

  const handleSendOtp = async()=>{
    let res;
    try {
      setIsLoading(true);
      const payload = {email: decryptedEmail};
        res = await resendOtp({ values: payload, dispatch });
      if (res?.status === "SUCCESS") {
        setIsLoading(false);
        setShowOtpInput(true);
        setIsOtpSent(true);
        success(res?.message);
      }else{
        setIsLoading(false);
        failed(res?.message);
      }
    } catch (error) {
      setIsLoading(false);
      failed(res?.message);
    }
  };

  const handleOtpChange = async (otpValue) => {
    setOtp(otpValue);
    formik.setFieldValue("otp", otpValue);
    if (otpValue.length === 6) {
      setIsLoading(true);
      try {
        const res = await verifyOtp({ values: { email: decryptedEmail, otp: otpValue }, dispatch });
        if (res?.status === "SUCCESS") {
          success("OTP verified successfully.");
          setIsOtpVerified(true);
          setIsLoading(false);
        } else {
          failed("Invalid OTP. Please try again.");
          setIsLoading(false);
        }
      } catch (error) {
        failed("Error verifying OTP.");
      } finally {
        setIsLoading(false);
      }
    }
  };

	return (
    <Fragment>
      {isLoading ? <Loader /> : null}
      <div className="page-wrapper full-page">
        <div className="header-wrapper w-nav">
          <div className="container-default w-container">
            <div className="header-content-wrapper">
              <div className="header-middle header-v3">
                <a>
                <img src="/assets/icons/group_logo_carematics.svg" alt="text_logo" className="logo_png" />
                </a>
              </div>
            </div>
          </div>
        </div>
        <div className="section sign-in-section">
          <div className="image-container sign-in-section">
            <div className="image-wrapper shape section-hero---sign-in---shape-01">
              <img src="/assets/icons/WELCOME-YELLOW-CIRCLE.svg" alt="" />
            </div>
            <div className="position-absolute sign-in-shape-wrapper">
              <div className="image-wrapper shape section-hero---sign-in---shape-02">
                <img src="/assets/icons/WELCOME-BLUE-LINES.svg" alt="" />
              </div>
              <div className="image-wrapper transform-origin-bottom">
                <img src="/assets/icons/WELCOME-RED-CIRCLE.svg" alt="" />
              </div>
              <div className="image-wrapper">
                <img src="/assets/icons/WELCOME-RECTANGLE.svg" alt="" />
              </div>
            </div>
          </div>
          <div className="container-default z-index-1 width-100 w-container">
            <div className="inner-container _640px center">
              <div className="text-center mg-bottom-48px forgot">
                <h1 className="display-1 mg-bottom-8px welcom_blk forgot">
                  Reset Password
                </h1>
                <p className="color-neutral-700 mg-bottom-0 welcom_desc">
                    Do not want to reset?{" "}
                    <a href="/login" className="text-blue-600 hover:underline">
                        Sign In
                    </a>
                </p>
              </div>
              <div className="card sign-up-form shadow-02 w-form login_form">
                <Form onSubmit={formik.handleSubmit} className="form_block">
                  <FormGroup className="spacing_three">
                    <Input
                      id="email"
                      name="email"
                      placeholder="Email"
                      type="email"
                      disabled={true}
                      value={maskEmail(decryptedEmail)}
                      readOnly
                    />
                    <img src="/assets/icons/welcom-email.svg" alt="text_logo" />
                  </FormGroup>
                  <FormGroup className="spacing_three">
                      <Input
                        id="telecom"
                        name="telecom"
                        placeholder="Phone"
                        type="phone"
                        disabled={true}
                        value={maskPhoneNumber(phoneNumber)}
                        onChange={formik.handleChange}
                      />
                      <img src={phoneImg} alt="text_logo" />
                  </FormGroup>
                  {showOtpInput && (
                  <FormGroup className="spacing_three">
                     <OtpInput
                      value={otp}
                      onChange={handleOtpChange}
                      numInputs={6}
                      shouldAutoFocus={!isOtpVerified}
                      renderSeparator={<span>-</span>}
                      renderInput={(props) => <input {...props}  disabled={isOtpVerified} />}
                      inputStyle={{
                        border: "1px solid",
                        borderRadius: "8px",
                        width: "100%",
                        height: "54px",
                        fontSize: "18px",
                        color: "#000",
                        fontWeight: "400",
                        caretColor: "blue",
                        padding:"25px 0px 16px 0px",
                        display:"flex",
                        justifyContent:"center"
                      }}
                      focusStyle={{
                        border: "1px solid #CFD3DB",
                        outline: "none"
                      }}
                    />
                    {/* <img src="/assets/icons/welcom-email.svg" alt="text_logo" /> */}
                    {formik.touched["otp"] && formik.errors["otp"] ? (
                      <span style={{ color: "red" }}>
                        {formik.errors["otp"]}
                      </span>
                    ) : null}
                  </FormGroup>)}
                  <div className="flex items-start space-x-4 text-gray-700 text-sm">
                        <input
                        type="checkbox"
                        id="terms"
                        checked={isChecked}
                        disabled={isChecked}
                        style={{width:"70px",height:"95px"}}
                        onChange={() => setIsChecked(!isChecked)}
                        className="w-7 h-4 mt-1 cursor-pointer"
                        />
                        <p htmlFor="terms" className="cursor-pointer" style={{marginLeft:"10px",fontWeight:"400"}}>
                        I agree to receive text messages from CareMatics at the phone number provided. Message and data rates may apply. Reply STOP to unsubscribe at any time. View our{" "}
                        <a href="/privacy" className="text-blue-600 hover:underline"
                        >
                            Privacy Policy
                        </a> and {" "}<a href="/terms" className="text-blue-600 hover:underline">
                            Terms & Conditions
                        </a>{" "}
.
                        </p>
                    </div>
                  {!isOtpVerified &&
                  <Button onClick={handleSendOtp} disabled={!isChecked} className="spacing_five mb-4">
                    {isOtpSent ? "Resend OTP" : "Send OTP to Phone Number"}
                  </Button>}
                  <br></br>
                  <br></br>
                  {isOtpVerified && (
                      <>
                        {/* New Password Field */}
                        <FormGroup className="spacing_three_password">
                          <Input
                            id="examplePassword"
                            name="newPassword"
                            placeholder="New Password"
                            type={!formik.values.showPassword ? "text" : "password"}
                            value={formik.values.newPassword}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            required
                          />
                          <img src="/assets/icons/Lock.svg" alt="lock_icon" />
                          <i
                            className={`fa ${!formik.values.showPassword ? "fa-eye" : "fa-eye-slash"}`}
                            onClick={() => formik.setFieldValue("showPassword", !formik.values.showPassword)}
                          ></i>
                          {formik.touched.newPassword && formik.errors.newPassword && (
                            <span style={{ color: "red" }}>{formik.errors.newPassword}</span>
                          )}
                        </FormGroup>

                        {/* Confirm Password Field */}
                        <FormGroup className="spacing_three_password">
                          <Input
                            id="confirmPassword"
                            name="cPassword"
                            placeholder="Confirm New Password"
                            type={!formik.values.showCPassword ? "text" : "password"}
                            value={formik.values.cPassword}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            required
                          />
                          <img src="/assets/icons/Lock.svg" alt="lock_icon" />
                          <i
                            className={`fa ${!formik.values.showCPassword ? "fa-eye" : "fa-eye-slash"}`}
                            onClick={() => formik.setFieldValue("showCPassword", !formik.values.showCPassword)}
                          ></i>
                          {formik.touched.cPassword && formik.errors.cPassword && (
                            <span style={{ color: "red" }}>{formik.errors.cPassword}</span>
                          )}
                        </FormGroup>
                      </>
                    )}
                  {isOtpVerified &&
                  <Button type="submit" className="spacing_five mb-4"  disabled={!formik.values.otp} >
                    Reset Password
                  </Button>}
                  <br></br>
                  <br></br>
                  <p className="color-neutral-700 mg-bottom-0 welcom_desc">
                    Do not want to Reset Password?{" "}
                    <a href="/login" className="text-blue-600 hover:underline">
                        Sign In
                    </a>
                </p>
                </Form>
              </div>
            </div>
          </div>
        </div>
        <footer>
          <p>Copyright © 2024 AimCare LLC</p>
        </footer>
      </div>
    </Fragment>
  );
}
export default ResetPassword;
